/**
 * Shopify Ajaxify Shop. 
 * 
 * @uses Modified Shopify jQuery API
 *
 */

// Función toast para mostrar mensajes visuales
function showToast(message) {
  var toast = jQuery('#toast-message');
  if (toast.length === 0) {
    toast = jQuery('<div id="toast-message"></div>').appendTo('body');
    toast.css({
      display: 'none',
      position: 'fixed',
      bottom: '20px',
      left: '50%',
      transform: 'translateX(-50%)',
      backgroundColor: '#323232',
      color: '#fff',
      padding: '12px 24px',
      borderRadius: '4px',
      fontSize: '14px',
      zIndex: '9999',
      boxShadow: '0 2px 10px rgba(0,0,0,0.3)',
    });
  }

  toast.text(message).fadeIn(400);

  setTimeout(function () {
    toast.fadeOut(400);
  }, 3000);
}

jQuery(document).ready(function () {
  // Begin Wrapper

  var jQ = jQuery;

  var selectors = {
    TOTAL_ITEMS: '.cart-total-items',
    TOTAL_PRICE: '.cart-total-price',
    SUBMIT_ADD_TO_CART: 'input[type=image], input.submit-add-to-cart',
    FORM_ADD_TO_CART: 'form[action*="/cart/add"]',
    FORM_UPDATE_CART: 'form[name=cartform]',
    FORM_UPDATE_CART_BUTTON: 'form[name=cartform] input[name=update]',
    FORM_UPDATE_CART_BUTTONS: 'input[type=image], input.button-update-cart',
    LINE_ITEM_ROW: '.cart-line-item',
    LINE_ITEM_QUANTITY_PREFIX: 'input#updates_',
    LINE_ITEM_PRICE_PREFIX: '.cart-line-item-price-',
    LINE_ITEM_REMOVE: '.remove a',
    EMPTY_CART_MESSAGE: '#empty'
  };

  var text = {
    ITEM: 'Artículo',
    ITEMS: 'Artículos'
  };

  var formatMoney = function (price) {
    return Shopify.formatMoney(price, '${{ amount }}');
  };

  // Manejar agregar al carrito
  jQ(selectors.FORM_ADD_TO_CART).submit(function (e) {
    e.preventDefault();
    jQ(e.target).find(selectors.SUBMIT_ADD_TO_CART).attr('disabled', true).addClass('disabled');
    Shopify.addItemFromForm(e.target);
  });

  // Actualizar carrito sin salir de la página
  jQ(selectors.FORM_UPDATE_CART_BUTTON).click(function (e) {
    e.preventDefault();
    jQ(e.target.form).find(selectors.FORM_UPDATE_CART_BUTTONS).attr('disabled', true).addClass('disabled');
    Shopify.updateCartFromForm(e.target.form);
  });

  // Eliminar productos del carrito
  jQ(selectors.FORM_UPDATE_CART).delegate(selectors.LINE_ITEM_REMOVE, 'click', function (e) {
    e.preventDefault();
    var vid = this.href.split('/').pop().split('?').shift();
    Shopify.removeItem(vid);
    jQ(this).parents(selectors.LINE_ITEM_ROW).remove();
  });

  // Producto agregado al carrito
  Shopify.onItemAdded = function (line_item, form) {
    jQ(form).find(selectors.SUBMIT_ADD_TO_CART).attr('disabled', false).removeClass('disabled');
    showToast('Producto agregado al carrito');
    Shopify.getCart();
  };

  // Actualizar vista del carrito
  Shopify.onCartUpdate = function (cart, form) {
    var message = '<span class="count">' + cart.item_count + '</span> ';
    jQ(selectors.TOTAL_ITEMS).html(message);

    var price = formatMoney(cart.total_price);
    jQ(selectors.TOTAL_PRICE).html(price);

    if ((jQ(selectors.EMPTY_CART_MESSAGE).length > 0) && cart.item_count == 0) {
      jQ(selectors.FORM_UPDATE_CART).hide();
      jQ(selectors.EMPTY_CART_MESSAGE).show();
    }

    form = form || false;

    if (form) {
      if (cart.item_count > 0) {
        jQ.each(cart.items, function (index, cartItem) {
          jQ(selectors.LINE_ITEM_PRICE_PREFIX + cartItem.id).html(formatMoney(cartItem.line_price));
          jQ(selectors.LINE_ITEM_QUANTITY_PREFIX + cartItem.id).val(cartItem.quantity);
        });

        jQ(form).find('input[value=0]').parents(selectors.LINE_ITEM_ROW).remove();
        jQ(form).find(selectors.FORM_UPDATE_CART_BUTTONS).attr('disabled', false).removeClass('disabled');
      }
    }
  };

  // Manejo de errores
  Shopify.onError = function (XMLHttpRequest, textStatus) {
    // Puedes personalizar la visualización de errores si lo deseas
    var data = JSON.parse(XMLHttpRequest.responseText);
    showToast('Error: ' + data.message);
  };

  // End Wrapper
});
